import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Row Types ───

export interface PatientTreatmentRecordRow {
  id: string;
  org_id: string;
  clinic_id: string | null;
  patient_id: string;
  encounter_id: string | null;
  invoice_id: string | null;
  invoice_item_id: string | null;
  /** PRD.243 — 'procedure' (clinical) | 'adjustment' (reflected billing event). */
  kind: string | null;
  /** PRD.243 — back-reference to the billing_adjustments row this reflects. */
  billing_adjustment_id: string | null;
  date: string; // YYYY-MM-DD
  tooth_nos: string | null;
  procedure_name: string;
  amount_charged_cents: number;
  amount_paid_cents: number;
  next_appointment_at: string | null;
  notes: string | null;
  created_at: string | null;
  updated_at: string | null;
  updated_by: string | null;
}

// ─── Queries ───

/**
 * All treatment records for a patient, newest date first.
 */
export function qTreatmentRecordsByPatient(patientId: string): QuerySpec<[string]> {
  return {
    key: ['patient_treatment_records', 'by-patient', patientId] as const,
    sql: `SELECT * FROM patient_treatment_records WHERE patient_id = ? ORDER BY date DESC, created_at DESC`,
    params: [patientId],
    watch: ['patient_treatment_records'],
  };
}

/**
 * Recent treatment records for sidebar preview (last 4).
 */
export function qRecentTreatmentRecords(patientId: string): QuerySpec<[string]> {
  return {
    key: ['patient_treatment_records', 'recent', patientId] as const,
    sql: `SELECT * FROM patient_treatment_records WHERE patient_id = ? ORDER BY date DESC, created_at DESC LIMIT 4`,
    params: [patientId],
    watch: ['patient_treatment_records'],
  };
}
